<div class="university-card" (click)="routerLink()">

  <!-- Logo -->
  <div class="logo">
    <p-avatar
      *ngIf="logo; else defaultAvatar"
      [image]="$any(logo)"
      shape="circle"
      size="large"
      (onImageError)="onImageError()"
    />
    <ng-template #defaultAvatar>
      <p-avatar
        [label]="getInitials(name())"
        [icon]="!name() ? 'pi pi-building' : undefined"
        shape="circle"
        size="large"
      />
    </ng-template>
  </div>

  <!-- Name and Description -->
  <div class="details">
    <h3 class="name">{{ name() | uppercase }}</h3>
    <p class="description">{{ description() | uppercase }}</p>
  </div>

  <!-- Contact Details -->
  <div class="contact-info">

    <div class="country d-flex align-items-center justify-content-center">
      <div class="icon">
        <img src="/icons/globe.svg" alt="Country Icon" />
      </div>
      <p>{{ country() }}</p>
    </div>

    <div class="phone">
      <div class="icon">
        <img src="/icons/phone.svg" alt="Phone Icon" />
      </div>
      <span>{{ phone() }}</span>
    </div>

    <div class="email">
      <div class="icon">
        <img src="/icons/email.svg" alt="Email Icon" />
      </div>
      <span>{{ email() }}</span>
    </div>
  </div>

  <!-- Navigation Icon -->
  <div class="navigate" (click)="ShowDetais($event)">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        d="M9.5 13a1.5 1.5 0 1 1-3 0
           1.5 1.5 0 0 1 3 0m0-5
           a1.5 1.5 0 1 1-3 0
           1.5 1.5 0 0 1 3 0m0-5
           a1.5 1.5 0 1 1-3 0
           1.5 1.5 0 0 1 3 0"/>
    </svg>
  </div>

  <div class="details-card" *ngIf="Show">
    <button type="button" (click)="routerLink()">Ver detalhes</button>
    <button type="button" (click)="AddRepresent($event)">Adicionar representante</button>
  </div>

</div>
